import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Header from '../Components/Header';

const SuccessContainer = styled.div`
  min-height: 100vh;
  background-color: white;
  font-family: 'Noto Sans Thai', sans-serif !important;
  font-weight: bold;
  * {
    font-family: 'Noto Sans Thai', sans-serif !important;
    font-weight: bold;
  }
`;

const SuccessContent = styled.div`
  padding: 60px 24px 40px 24px;
  max-width: 400px;
  margin: 0 auto;
  text-align: center;
  
  @media (max-width: 768px) {
    max-width: 100%;
    padding: 60px 20px 40px 20px;
  }
`;

const SuccessImageContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 48px;
`;

const SuccessImage = styled.img`
  width: 120px;
  height: 120px;
  object-fit: contain;
`;

const SuccessTitle = styled.h1`
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 16px;
  text-align: center;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const SuccessSubtitle = styled.p`
  font-size: 18px;
  color: #666;
  margin-bottom: 80px;
  text-align: center;
  font-weight: bold;
  font-family: 'Noto Sans Thai', sans-serif !important;
  line-height: 1.5;
`;

const ContinueButton = styled.button`
  background-color: #00BBD3;
  color: white;
  border: none;
  border-radius: 30px;
  padding: 18px 32px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  font-family: 'Noto Sans Thai', sans-serif !important;
  box-shadow: 0 9px 14px 0 rgba(0, 187, 211, 0.08);

  &:hover {
    background-color: #009bb3;
  }

  &:active {
    background-color: #008aa0;
  }
`;

const SuccessPage = () => {
  const navigate = useNavigate();

  // Auto redirect หลังจาก 5 วินาที (optional)
  useEffect(() => {
    const timer = setTimeout(() => {
      handleContinue();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const handleContinue = () => {
    navigate('/dashboard');
  };

  return (
    <SuccessContainer>
      <Header />
      
      <SuccessContent>
        <SuccessImageContainer>
          <SuccessImage src="./ติ้กถูก.png" alt="Success" />
        </SuccessImageContainer>

        <SuccessTitle>เข้าสู่ระบบสำเร็จ</SuccessTitle>
        
        <SuccessSubtitle>
          ยินดีต้อนรับสู่ MFU wellness center
        </SuccessSubtitle>
        
        <ContinueButton onClick={handleContinue}>
          เข้าสู่หน้าหลัก
        </ContinueButton>
      </SuccessContent>
    </SuccessContainer>
  );
};

export default SuccessPage;